<template>
    <div class="fd-charts" :id="scope.id" ></div>
</template>

<script>
import echarts from 'echarts';
import $ from 'jquery';
export default {
    name: 'echarts-base',
    components:{echarts},
    props: {
        options: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        autoplay: {type: Boolean},
        mouseEvent: {type: Boolean},
        clickCallback: {type: Function}
    },
    data: function () {
        return {
            scope: {
                options: this.options,
                id: this.id,
                autoplay: this.autoplay,
                clickCallback: this.clickCallback,
                mouseEvent: this.mouseEvent
            }
        };
    },
    watch: {
        options: {
            deep: true,
            handler: function () {
                this.update(this);
            }
        }
    },
    // 插入到真实dom后
    mounted: function () {
        const _this = this;
        // 初始化
        _this.init();
    },
    methods: {
        // 更新图表
        update: function (scope) {
            // 生成图表
            this.$nextTick(function () {
                scope.myChart.clear();
                scope.myChart.setOption(scope.options);
            });
        },
        // 销毁图表
        destory: function () {
            const _this = this;
            $(window).off(`resize.${_this.scope.id}`);
            _this.myChart.clear();
            _this.myChart.dispose();
        },
        // 绑定事件
        bindEvent: function () {
            const _this = this;
            // 绑定resize事件
            $(window).off(`resize.${_this.scope.id}`)
                .on(`resize.${_this.scope.id}`, function () {
                    _this.myChart.resize();
                });
        },
        // 创建图表
        createChart: function () {
            const _this = this;
            // 生成图表实例
            _this.myChart = echarts.init(document.getElementById(_this.scope.id));
            // 生成图表
            _this.myChart.setOption(_this.scope.options);

            /* 绑定事件*/
            if (_this.scope.clickCallback) {
                _this.myChart.on('click', function (param) {
                    _this.scope.clickCallback(param);
                });
                _this.myChart.on('legendselectchanged', function (param) {
                    _this.scope.clickCallback(param);
                    window.console.log(param);
                });
            }

            /* 轮播tooltip*/
            if (_this.scope.autoplay) {
                let index = 0;
                const _NUM = 2000;
                _this.mTime = setInterval(function () {
                    _this.myChart.dispatchAction({
                        type: 'showTip',
                        seriesIndex: 0,
                        dataIndex: index
                    });
                    index++;
                    if (index >= _this.options.series[0].data.length) {
                        index = 0;
                    }
                }, _NUM);
            }

            /* 轮播tooltip*/
            if (this.scope.mouseEvent) {
                _this.myChart.on('mouseover', function (params) {
                    _this.scope.options.series[0].data[params.dataIndex].label.show = true;
                    _this.scope.options.series[0].data[params.dataIndex].labelLine.show = true;
                });
                _this.myChart.on('mouseout', function (params) {
                    _this.scope.options.series[0].data[params.dataIndex].label.show = false;
                    _this.scope.options.series[0].data[params.dataIndex].labelLine.show = false;
                });
            }
        },
        // 初始化函数
        init: function () {
            const _this = this;
            // 创建图表
            _this.createChart();
            // 绑定事件
            _this.bindEvent();
        }
    }
};
</script>
<style lang="less" scoped>
.fd-charts {
    width: 100%;
    height: 100%;
}
</style>>
